import { Record as record } from 'immutable';

import { getDefaults, getResolvers } from '../../../helpers/Records';
import { construct, fields } from '../../../helpers/LinkMapper';

const fieldSchema = {
    percent: [ fields.number ],
    discountTypes: [ fields.string ]
};

class DiscountInfo extends record(getDefaults(fieldSchema)) {
    static fromJSON (json = {}) {
        return construct(DiscountInfo, json, getResolvers(fieldSchema));
    }
}

export default DiscountInfo;
